'use client'

import ArticleCard from "@/components/ArticleCard"
import PressCard from "@/components/PressCard"
import { Masonry } from 'react-masonry'

interface NewsMasonryProps {
	data: any
}

export default function NewsMasonry({data}:NewsMasonryProps) {
	return (
		<Masonry>
			{data?.map((article, index) => (
				article?._type === "press" ? (
					<div key={`${article.title}-${index}`} className={`w-full sm:w-1/2 md:w-[33.3%] px-2 sm:px-3 md:px-4 pb-section--sm`}>
						<PressCard
							key={`${article.title}-${index}`}
							headline={article?.title}
							date={article?.publishedDate}
							url={article?.url}
							image={article?.image}
							video={article?.video}
							excerpt={article?.excerpt || article?.title}
						/>
					</div>
				) : (
					<div key={`${article.title}-${index}`} className={`w-full sm:w-1/2 md:w-[33.3%] px-2 sm:px-3 md:px-4 pb-section--sm`}>
						<ArticleCard
							key={`${article.slug}-${index}`}
							headline={article?.title}
							tag={article?.tag?.title}
							date={article?.publishedDate}
							url={`/news/${article?.slug}`}
							image={article?.image}
							video={article?.video}
							excerpt={article?.excerpt || article?.title}
						/>
					</div>
				)
			))}
		</Masonry>
	)
}